// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_ActivityEventTrafficSource.proto

export enum ENUM_ActivityEventTrafficSource {
  ACTIVITY_EVENT_TRAFFIC_SOURCE_UNSPECIFIED = 'ACTIVITY_EVENT_TRAFFIC_SOURCE_UNSPECIFIED',
  ACTIVITY_EVENT_TRAFFIC_SOURCE_WEB_LOGIN = 'ACTIVITY_EVENT_TRAFFIC_SOURCE_WEB_LOGIN',
  ACTIVITY_EVENT_TRAFFIC_SOURCE_MOBILE_APP = 'ACTIVITY_EVENT_TRAFFIC_SOURCE_MOBILE_APP',
  ACTIVITY_EVENT_TRAFFIC_SOURCE_EMAIL = 'ACTIVITY_EVENT_TRAFFIC_SOURCE_EMAIL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
